/* eslint @typescript-eslint/strict-boolean-expressions: off */

import React from "react";
import styles from "gui/logos/logos.module.css";
import { Cell } from "gui/grid/cell";
import { Figure } from "gui/figure/figure";
import { Grid } from "gui/grid/grid";
import { SanityLogos } from "lib/sanity/types";

export const Logos: React.FC<{
  item: SanityLogos;
}> = (props) => {
  const id = `aria-${props.item._key}`;

  return (
    <Grid
      className={styles.logos}
      aria-labelledby={props.item.title && id}
      revealOnScroll
      gaps
    >
      {props.item.title && (
        <Cell as="h2" className={styles.title} id={id}>
          {props.item.title}
        </Cell>
      )}
      <Cell as="ul">
        {props.item.list.map((item) => (
          <li key={item._key}>
            <Figure item={item} width={150} format="png" />
          </li>
        ))}
      </Cell>
      {props.item.subtitle && (
        <Cell as="p" className={styles.subtitle}>
          {props.item.subtitle}
        </Cell>
      )}
    </Grid>
  );
};
